import { useTranslation } from 'react-i18next';
import { Button, ButtonOption } from '../Fundamentals/Button';
import type { RoundProgress } from './roundProgress';
import RoundProgressSummary from './RoundProgressSummary';

interface PricingSimulationHeaderProps {
    onSaveDraft: () => void;
    isSaving: boolean;
    onSendForApproval: () => void;
    roundProgress: RoundProgress | null;
}

const PricingSimulationHeader = ({ onSaveDraft, isSaving, onSendForApproval, roundProgress }: PricingSimulationHeaderProps) => {
    const { t } = useTranslation();

    return (
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-16 py-16 mb-24">
            <div>
                <h1 className="heading-lg m-0">{t('priceSimulation.pageTitle')}</h1>
                <p className="body-sm text-secondary m-0">{t('priceSimulation.subtitle')}</p>
            </div>
            <div className="d-flex flex-column">
                <span className="body-sm text-secondary">{t('priceSimulation.leftToAdjust')}</span>
                {roundProgress ? <RoundProgressSummary progress={roundProgress} /> : <span className="text-secondary">{t('priceSimulation.roundProgressUnavailable')}</span>}
            </div>
            <div className="d-flex align-items-center gap-8">
                <Button onClick={onSaveDraft} disabled={isSaving}>
                    {t('priceSimulation.saveAsDraft')}
                </Button>
                <Button onClick={onSendForApproval} option={ButtonOption.PRIMARY}>
                    {t('priceSimulation.sendForApproval')}
                </Button>
            </div>
        </div>
    );
};

export default PricingSimulationHeader;
